import script from "./AtlasIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./AtlasIcon.vue?vue&type=script&setup=true&lang=ts"

import "./AtlasIcon.vue?vue&type=style&index=0&id=715d0cdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-715d0cdc"]])

export default __exports__